export default "__VITE_ASSET__DrbB0pFa__"